export class GetAllNews {

    constructor() {
        this.command = "/ZasShopServicePage.aspx/?n=1&command=GET_NEWS"
    }

    callApi( type ) {
        fetch(this.command, {
            method: 'get'
        })
        .then(response => response.json())
        .then(data => {
            for (const item of data.root.info_items.info_item) {
                let data = Array.isArray(item.info_items.info_item) ? item.info_items.info_item : [item.info_items.info_item]
                if ( item.skupina == "Novinky") {
                    if( type == "news") {
                        this.renderNewsBannerHomepage(data)
                    }

                } else if ( item.skupina == "Aktuality" ) {
                    if( type == "actuality") this.renderActualities(data);
                }
            }
        })
        .catch(console.error);
    }
    renderNews(news){
        let block = document.getElementById("news");
        let newsTemplate = "";

        for (const newItem of news.info_items.info_item) {
            newsTemplate +=  "<div>" + newItem.datum + "<h2>" +  newItem.novinka_nadpis + "</h2><p>"+ newItem.novinka + "</p></div>" ;
        }

        if( block ){
            block.innerHTML = newsTemplate;
        }

    }
    renderSlider(newItem){

        if(newItem.home_page){
            let homeSlick = document.getElementsByClassName("slick-home")[0];
            let wrapper = document.createElement("div");
            wrapper.setAttribute("class", "slick-wrapper")
            wrapper.innerHTML = newItem.novinka
            homeSlick.appendChild(wrapper)
        }



    }
    renderNewsBannerHomepage(news){

        for(let item of news){
            this.renderSlider(item)
        }

    }
    renderActualities(item){
        let block = document.getElementById("actuality");
        let newsTemplate = "";

        for (const newItem of item) {
            newsTemplate +=
            "<div><h2>" + newItem.novinka_nadpis + "</h2>" + newItem.novinka  +
            "</div>";
        }

        block.innerHTML = newsTemplate;
    }

}
